import React, { useEffect, useState } from "react"
import CollectionGallery from "../components/collection-gallery"
import Layout from "../components/layout"
import Seo from "../components/seo"
import StoryPage from "../components/story-page"
import StoryTopInfo from "../components/story-top-info"
import constants from "../constants"
import Store from "../store"
import useLockBodyScroll from "../components/useLockBodyScroll"
import LookbookInformation from "../components/lookbook-information"
import Locals from "../components/localsColour.json"
import ScrollingPositions from "../components/scrollingColour.json"
import Actions from "../actions"
import * as queryString from "query-string"

const ColourStory = (props) => {
  const [isLookbookOpen, setIsLookbookOpen] = useState(false)
  const [transition, setTransition] = useState(`in`)
  const collectionSlides = props.pageContext.allColourLookbookJson.nodes
  const layout = props.pageContext.allColourLayoutJson.nodes[0]
  const lang = props.pageContext.lang
  const {
    text2,
  } = props.pageContext.landingJson.words
  useEffect(() => {
    const urlQuery = queryString.parse(window.location.search)
    const onOpenLookbook = () => {
      setTransition(`in`)
      setIsLookbookOpen(true)
    }
    const onCloseLookbook = () => {
      setTransition(`out`)
      setTimeout(setIsLookbookOpen, 900, false)
    }
    setTimeout(Actions.updateStory, 0, constants.COLOUR)
    if (urlQuery && urlQuery.slideshow && urlQuery.slideshow === `true`) {
      setTimeout(Actions.openLookbook, 1000)
    }
    Store.on(constants.OPEN_LOOKBOOK, onOpenLookbook)
    Store.on(constants.CLOSE_LOOKBOOK, onCloseLookbook)
    return () => {
      Store.off(constants.OPEN_LOOKBOOK, onOpenLookbook)
      Store.off(constants.CLOSE_LOOKBOOK, onCloseLookbook)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useLockBodyScroll(isLookbookOpen)
  return (
    <Layout className={`overflow-scroll-y w-full h-screen overflow-x-hidden`}>
      <Seo title="Colour Story" description={text2} lang={lang} />
      <div className={`w-full h-full`}>
        <StoryTopInfo lang={lang} transition={transition} state={isLookbookOpen ? `close` : `open`} id={`colour`} className={`fixed top-6 right-6 lg:top-8 lg:right-8 z-20`} />
        <StoryPage state={isLookbookOpen ? `close` : `open`} lang={lang} id={`colour`} data={layout} scrollingPositions={ScrollingPositions} locals={Locals[lang]} />
        { isLookbookOpen &&
        <div className={``}>
          <div className={`relative`}>
            <LookbookInformation lang={lang} transition={transition} prefix={`colour`} locals={Locals} />
          </div>
        </div>
        }
        { isLookbookOpen &&
        <CollectionGallery
          lang={lang}
          transition={transition}
          className={`w-screen h-screen overflow-hidden fixed top-0 left-0`}
          items={collectionSlides}
        />
        }
      </div>
    </Layout>
  )
}

export default ColourStory
